import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsPanelTab/reducerGenerator'
import {CLOSE_ALL_PANELS} from '../common/actionTypes'
import {RESET_CREATE_USER_PANEL_STATE} from '../../../panels/user/createPanel/actionTypes'

const hierarchyAssignmentsPanelReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsPanelReducer.initialState,
    loaded: true,
    isShown: false,
    allScopeSelected: false,
}

const managementAssignmentsPanel = handleActions({
    ...hierarchyAssignmentsPanelReducer.handlers,
    [ActionTypes.SHOWN_SET]: (state, {payload: isShown}) => ({...state, isShown: isShown}),
    [ActionTypes.ALL_SCOPE_SET]: (state, {payload: allScopeSelected}) => ({...state, allScopeSelected: allScopeSelected}),
    [RESET_CREATE_USER_PANEL_STATE]: (state) => ({...state, ...initialState}),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        isShown: false,
        userId: null,
        tab: null,

        taskIds: [],
        projectIds: [],
        customerIds: [],
        manageTaskIds: {},
        manageProjectIds: {},
        manageCustomerIds: {},

        userCounters: {
            customers: 0,
            projects: 0,
            tasks: 0,
        },

        searchString: '',
        isShowArchivedEntities: false,
    }),
}, initialState)

export default managementAssignmentsPanel



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/reducer.js